import {Action} from '@ngrx/store';

import {ResidentStatistics} from '../entities/resident.statistics';

export const SET_STATISTICS = '[ResidentStatistics] Set';

export class SetStatistics implements Action {
	readonly type = SET_STATISTICS;

	payload: {
		data: ResidentStatistics;
	};

	constructor(data: ResidentStatistics) {
		this.payload = {
			data
		};
	}
}

export type Actions = SetStatistics;
